<template>
  <div class="operation-container">
    <div class="tabs">
      <div
        class="tab-item"
        v-for="(item, index) in menuList"
        :key="item.name"
        @click="changeTab(index)"
        :style="{ color: index == current ? '#008585' : '#515151' }"
      >
        {{ item.label }}
      </div>
      <div class="tab-item" @click="loginout">退出登陆</div>
    </div>
    <div class="components-content">
      <component :is="componentName" />
    </div>
  </div>
</template>
<script>
import addOperationProject from "./add-operational-projects.vue";
import faultTypeVue from "./faultType.vue";
import FormComponent from "./form.vue";
import Core from "@/libs/src/core";
export default {
  components: {
    addOperationProject,
    FormComponent,
    faultTypeVue,
  },
  data() {
    return {
      current: 0,
      componentName: "FormComponent",
      tabPosition: "left",
      menuList: [
        // {
        //   label: "添加运维项",
        //   name: "addOperationProject",
        // },
        {
          label: "表单管理",
          name: "FormComponent",
        },
        {
          label: "运维故障类型",
          name: "faultTypeVue",
        },
      ],
    };
  },
  created() {
    const Auth = Core.providers.get(Core.providerTypes.Auth);
    if (Auth.isAdmin()) {
      this.menuList.unshift({
        label: "添加运维项",
        name: "addOperationProject",
      });
      this.current = 1
    }
  },
  methods: {
    loginout() {
      Core.data.VueRouter.push("/login");
    },
    changeTab(index) {
      this.current = index;
      this.componentName = this.menuList[index].name;
    },
  },
};
</script>
<style lang="scss" scoped>
.operation-container {
  height: 100vh;

  padding: 10px;
  display: flex;
  .tabs {
    flex: 1;
    color: #515151;
    box-sizing: border-box;
    border-right: 1px solid #e6e6e6;
  }
  .components-content {
    flex: 9;
    padding: 15px;
    box-sizing: border-box;
    height: 100%;
  }
  .tab-item {
    color: #333;
    padding: 10px;
    border-bottom: 1px solid #e6e6e6;
    &:hover {
      color: #008585;
      cursor: pointer;
    }
  }
}
</style>